import { Arbeitsbereich } from './Arbeitsbereich';

export class Mitarbeiter {
  readonly vorname: string;
  readonly nachname: string;
  readonly arbeitsbereich: Arbeitsbereich;
  readonly abteilung?: string;
  readonly imgUrl?: string;
  readonly extern?: boolean;
  readonly id: string;

  constructor({
    vorname,
    nachname,
    arbeitsbereich,
    abteilung,
    imgUrl,
    id,
    extern = false,
  }: {
    vorname: string;
    nachname: string;
    arbeitsbereich: Arbeitsbereich;
    abteilung?: string;
    imgUrl?: string;
    id: string;
    extern?: boolean;
  }) {
    this.vorname = vorname;
    this.nachname = nachname;
    this.arbeitsbereich = arbeitsbereich;
    this.abteilung = abteilung;
    this.imgUrl = imgUrl;
    this.extern = extern;
    this.id = id;
  }
}
